<template>
  <div class="events">
    <h1 class="events__title page-title">Events</h1>

    <add-new-event />

    <el-tabs
      v-model="activeTab" readonly
      class="events__tabs"
      @tab-click="handleChangeTab"
    >
      <el-tab-pane label="Search" name="search" lazy>
        <search-events />
      </el-tab-pane>
      <el-tab-pane label="Active" name="active" lazy>
        <active-events />
      </el-tab-pane>
      <el-tab-pane label="Past" name="past" lazy>
        <past-events />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import SearchEvents from '@/components/events/SearchEvents.vue';
import ActiveEvents from '@/components/events/ActiveEvents.vue';
import PastEvents from '@/components/events/PastEvents.vue';
import EventPage from '@/components/events/EventPage.vue';
import AddNewEvent from '@/components/events/AddNewEvent.vue';

export default {
  name: 'UserEvents',
  components: {
    SearchEvents,
    ActiveEvents,
    PastEvents,
    EventPage,
    AddNewEvent,
  },
  computed: {
    activeTab: {
      get() {
        return this.$route.query.tab || 'search';
      },
      set(value) {
        this.$router.push({
          query: {
            tab: value,
          },
        });
      },
    },
    eventId() {
      return Number(this.$route.params.eventId) || null;
    },
  },
  methods: {
    handleChangeTab({ name }) {
      const { activeTab } = this;

      if (name !== activeTab) {
        this.$router.push({
          route: 'UserProfile',
          query: {
            tab: name,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/shared/_globals.scss';

.events {
  &__title {
    margin: 0;
    margin-bottom: var(--global-dimension-size-250);

    font-weight: 500;
    font-size: var(--font-size-800);
    line-height: 1.6;
  }

  &__tabs {
    .el-tabs__item {
      font-size: var(--font-size-300);
      line-height: 1.6;
    }
    .el-tabs__header {
      margin-bottom: var(--global-dimension-size-350);
    }
  }
}
</style>
